import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import type { IUseCase } from '@/shared/contracts/use-case.contract';
import { UIError } from '@/shared/utils/ui-error';
import { atendimentoEndpoint, type AtendimentoCliente } from '../types';

// Sem `id` cria o cliente (POST, exige telefone); com `id` corrige o nome (PATCH).
type Input = { slug: string; id?: string; name: string; phone?: string };

export class SalvarAtendimentoClienteUseCase implements IUseCase<Input, AtendimentoCliente> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute({ slug, id, name, phone }: Input): Promise<AtendimentoCliente> {
    const nome = name.trim();
    if (!nome) throw new UIError('NOME_OBRIGATORIO', 'Informe o nome do cliente.');

    if (id) {
      const response = await this.client.sendRequest<{ data: AtendimentoCliente }, object>({
        endpoint: `${atendimentoEndpoint(slug)}/clientes/${encodeURIComponent(id)}`,
        method: HttpMethod.PATCH,
        body: { name: nome },
      });
      return response.data;
    }

    if (!phone) throw new UIError('TELEFONE_OBRIGATORIO', 'Informe o telefone do cliente.');

    const response = await this.client.sendRequest<{ data: AtendimentoCliente }, object>({
      endpoint: `${atendimentoEndpoint(slug)}/clientes`,
      method: HttpMethod.POST,
      body: { name: nome, phone },
    });
    return response.data;
  }
}
